package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.components.WebImage
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties
import org.multiplatform.kotfolio.util.Resources

@Page("our_school")
@Composable
fun KidsOurSchoolPage() {
    BlogLayout(
        PageProperties(
            "Our School",
            ""
        ),
        BlogProperties("Kids", "Our School")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Different Areas In A School",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Our school has different areas which we use to do different things.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Let us look at the different rooms in a school.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Classroom",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We sit and study in our classroom.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "There are separate tables and chairs for students.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Every classroom has a class board that the teacher uses to teach.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The soft boards on the walls are decorated with colourful charts and work done by the students.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should keep our classroom neat and clean.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Computer room",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "In the computer room, we learn how to use a computer and also play games on it.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Library",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Our school has a library which has many books such as comics, storybooks and reference books.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "It is a place for reading and studying.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The library is a room where we have to be very quiet otherwise we may disturb the other readers.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Sick room or medical room",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "When we are hurt or feel ill, we visit a medical room or sick room. The sick room has medicines and a first-aid kit. A nurse takes care of us in the sick room.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Art room",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We learn to draw, colour, paint and create beautiful pictures using colour pencils, paints, etc. with the art teacher in the art room. We also make different things in the art room.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Music and dance room",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We learn to sing, dance and play different musical instruments in the music and dance room.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Canteen",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Our school canteen provides healthy snacks and lunch. We can sit with friends in the canteen to eat our snacks and lunch.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Washroom",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Our school has separate washrooms for boys and girls.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Staffroom",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The teachers use the staffroom when they are not teaching in the class. Teachers correct books and prepare their lessons in the staffroom.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Assembly hall",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We gather in the assembly hall for morning prayers and assembly. Important announcements are made here. School functions and celebrations are also held in this hall.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Playground",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Our school also has a playground. Students play games in the playground during their break or physical exercise period. The playground also has slides, see-saws and swings.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Functions in the School",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We celebrate some important functions such as Children's Day, Teachers' Day, Annual Day and Sports Day.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We celebrate Teachers' Day on 5th September every year.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We celebrate Gandhi Jayanti on 2nd October every year.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "we celebrate Independence day on 15th August every year.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We celebrate Children's Day on 14th November every year.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "we celebrate Republic day on 26th January every year.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "India celebrates National Education Day on 11th November every year. Find out why it is celebrated.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We perform cultural activities like dances, skits and playing music on Annual Day.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "On Sports Day, our school organises many games and we participate in various sports activities.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We also celebrate important national holidays such as Independence Day, Republic Day and Gandhi Jayanti in our school.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "People who Work at School",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Different people help to make school a joyful and safe place.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            WebImage(
                src = Resources.Images.OUR_SCHOOL_WORK,
                modifier = Modifier.fillMaxWidth().padding(5.px).borderRadius(10.px),
                contentDescription = "People work at school"
            )

            SpanText(
                text = "Rules to Follow in the School",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Students should follow certain rules in school.",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Ul {
                    Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We should respect teachers, friends and other staff. We should greet them when we see them.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We should respect school property such as school furniture, the school building and the playground by not damaging them and by keeping them clean.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We should throw all the waste in the dustbin.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }

                    Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                        SpanText(
                            text = "We should walk in a line in the corridors.",
                            modifier = Modifier.fontSize(FontSize.Medium)
                        )
                    }
                }
            }

            SpanText(
                text = "Worksheet 2026-27",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "Choose the word from the box and fill in the blanks.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            SpanText(
                text = "[helper, security, guard driver, librarian, principal]",
                modifier = Modifier.fontSize(FontSize.Medium).padding(top = 1.em)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ drives us to school and back home. driver",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ helps us to choose books from the library. librarian",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ keeps the school and classrooms clean. helper",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ is the head of the school. principal",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The ________________ protects our school. security guard",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Write ‘T’ if the statement is true and write ‘F’ if the statement is false. ",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We learn to play musical instruments in the art room. F",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We should keep our classroom clean. T",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Circle the correct answer.",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em).fontWeight(FontWeight.Bold)
            )

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "We sit and study in this room where there are separate tables and chairs for students. This room is known as: Classroom",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Students learn to dance in this room. This area is known as: Dance room",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Students learn to draw, colour and paint beautiful pictures using colours. This area is known as: Art room",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(bottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Teachers sit here when they are not teaching in class. This room is known as: Staff room",
                        modifier = Modifier.fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}

//The name of which of these locations was changed to Tagore Square for a day during the centenary celebrations of Rabindranath Tagore? Times Square, New York.